const ACCOUNT_STORAGE_KEY = "account";
const REMEMBER_CREDENTIAL_STORAGE_KEY = "rememberCredential";
const LEGACY_REMEMBER_ACCOUNT_STORAGE_KEY = "rememberAccount";
const LEGACY_PASSWORD_STORAGE_KEY = "password";
const LEGACY_REMEMBER_PASSWORD_STORAGE_KEY = "rememberPassword";

export function migrateLegacyLoginStorage(storage) {
  const legacyRemembered =
    storage.getItem(LEGACY_REMEMBER_PASSWORD_STORAGE_KEY) === "true" ||
    storage.getItem(LEGACY_REMEMBER_ACCOUNT_STORAGE_KEY) === "true";
  const account = storage.getItem(ACCOUNT_STORAGE_KEY) || "";

  storage.removeItem(LEGACY_PASSWORD_STORAGE_KEY);
  storage.removeItem(LEGACY_REMEMBER_PASSWORD_STORAGE_KEY);
  storage.removeItem(LEGACY_REMEMBER_ACCOUNT_STORAGE_KEY);

  if (legacyRemembered && account) {
    storage.setItem(REMEMBER_CREDENTIAL_STORAGE_KEY, "true");
  } else if (storage.getItem(REMEMBER_CREDENTIAL_STORAGE_KEY) !== "true") {
    storage.removeItem(ACCOUNT_STORAGE_KEY);
    storage.removeItem(REMEMBER_CREDENTIAL_STORAGE_KEY);
  }
}

export function loadRememberedAccount(storage) {
  const remember =
    storage.getItem(REMEMBER_CREDENTIAL_STORAGE_KEY) === "true";
  return {
    account: remember ? storage.getItem(ACCOUNT_STORAGE_KEY) || "" : "",
    remember,
  };
}

export function saveRememberedAccount(storage, remember, account) {
  storage.removeItem(LEGACY_PASSWORD_STORAGE_KEY);
  storage.removeItem(LEGACY_REMEMBER_PASSWORD_STORAGE_KEY);
  storage.removeItem(LEGACY_REMEMBER_ACCOUNT_STORAGE_KEY);
  if (remember && account) {
    storage.setItem(ACCOUNT_STORAGE_KEY, account);
    storage.setItem(REMEMBER_CREDENTIAL_STORAGE_KEY, "true");
    return;
  }
  storage.removeItem(ACCOUNT_STORAGE_KEY);
  storage.removeItem(REMEMBER_CREDENTIAL_STORAGE_KEY);
}
